export default "__VITE_ASSET__DCT90M_k__"